var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"score-report"}},[_c('report-page-header',{attrs:{"title":_vm.$t('attendance_report.main_page_title')}}),(_vm.shouldShowSingleStudentReport)?_c('student-tab'):_c('tabs',{attrs:{"tabs":_vm.tabs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }